"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
var react_1 = __importDefault(require("react"));
var react_infinite_scroll_component_1 = __importDefault(require("react-infinite-scroll-component"));
var react_2 = require("@emotion/react");
var react_3 = require("@chakra-ui/react");
var breadcrumb_1 = require("../../../common/breadcrumb");
var layout_1 = require("../../../common/layout");
var PageLoadingLayout_1 = require("../../../common/layout/PageLoadingLayout");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var CategoryTopImage_1 = require("../../../common/category/CategoryTopImage");
var useCategory_1 = require("./useCategory");
var useShop_1 = require("../../../common/hooks/useShop");
var PageNotFound_1 = require("../../../common/error/PageNotFound");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var Category = function () {
    var _a = (0, useCategory_1.useCategory)(), categoryDatas = _a.categoryDatas, productDatas = _a.productDatas, paginateData = _a.paginateData, nextScroll = _a.nextScroll, isCategoryLoading = _a.isCategoryLoading;
    var _b = (0, useShop_1.useShop)(), shopData = _b.shopData, isShopLoading = _b.isShopLoading, mainShopData = _b.mainShopData;
    if (isShopLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    if (!shopData)
        return (react_1.default.createElement(layout_1.Layout, { headerUrl: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.logo_image, shopCode: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.code },
            react_1.default.createElement(react_3.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
    return (react_1.default.createElement(layout_1.Layout, { headerUrl: shopData.logo_image, shopCode: shopData.code, isHeader: true, isFooter: true, isInquire: true, isLoading: isCategoryLoading },
        react_1.default.createElement(PageLoadingLayout_1.PageLoadingLayout, { isLoading: isCategoryLoading }, categoryDatas ? (react_1.default.createElement(react_1.default.Fragment, null,
            (0, useSetMeta_1.useSetMeta)(categoryDatas.name, categoryDatas.catchphrase, shopData.name),
            categoryDatas.breadcrumb ? (react_1.default.createElement(breadcrumb_1.BreadCrumb, { breadcrumbDatas: __spreadArray([
                    {
                        front_path: "main",
                        name: "TOP",
                    },
                    {
                        front_path: shopData.code,
                        name: shopData.name,
                    }
                ], categoryDatas.breadcrumb, true) })) : (react_1.default.createElement(breadcrumb_1.BreadCrumb, { breadcrumbDatas: [
                    {
                        front_path: "main",
                        name: "TOP",
                    },
                    {
                        front_path: shopData.code,
                        name: shopData.name,
                    },
                ] })),
            react_1.default.createElement(react_3.Box, { className: "container" },
                react_1.default.createElement(CategoryTopImage_1.CategoryTopImage, { categoryDatas: categoryDatas }),
                categoryDatas.child_categories && (react_1.default.createElement(react_3.Box, { padding: "5px", display: "flex", flexWrap: "wrap", justifyContent: "center" }, categoryDatas.child_categories.map(function (childCategorie, index) { return (react_1.default.createElement(react_3.Link, { href: "/" + childCategorie.front_path, key: "categoryButton-" + index, shallow: "true", margin: {
                        base: "2px",
                        md: "10px",
                    }, width: {
                        base: "32%",
                        md: "auto",
                    }, _hover: {
                        textDecoration: "none",
                    } },
                    react_1.default.createElement(react_3.Button, { width: "100%", padding: "0.3rem 2.5rem", border: "1px", borderColor: "#d4cdc3", backgroundColor: "white", _hover: {
                            backgroundColor: "gray.100",
                        }, borderRadius: "2px" }, childCategorie.name))); }))),
                react_1.default.createElement(react_3.Box, { mt: {
                        base: categoryDatas.child_categories
                            ? "none"
                            : "1rem",
                        md: categoryDatas.child_categories
                            ? "none"
                            : "2rem",
                    } }, productDatas && (react_1.default.createElement(react_infinite_scroll_component_1.default, { dataLength: productDatas.length, next: nextScroll, hasMore: (paginateData === null || paginateData === void 0 ? void 0 : paginateData.next_page_url)
                        ? true
                        : false, loader: react_1.default.createElement("h4", null, "Loading...") },
                    react_1.default.createElement(react_3.Box, { className: "row gutter-10", width: "100%" }, productDatas.map(function (productData, index) { return (react_1.default.createElement(react_3.Link, { key: "product-" + index, className: "col-6 col-md-2", href: "/" + productData.front_path, mb: "3rem" },
                        react_1.default.createElement(react_3.Box, { position: "relative", paddingTop: "100%" },
                            react_1.default.createElement(react_3.Box, { position: "absolute", top: "0", width: "100%", height: "100%" },
                                react_1.default.createElement(react_3.Image, { width: "100%", height: "100%", objectFit: "contain", background: "white", src: productData
                                        .main_image
                                        .file
                                        .s }))),
                        react_1.default.createElement(react_3.Text, { css: truncateStyle }, productData.name))); })))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(breadcrumb_1.BreadCrumb, { breadcrumbDatas: [
                    {
                        front_path: "main",
                        name: "TOP",
                    },
                    {
                        front_path: shopData.code,
                        name: shopData.name,
                    },
                ] }),
            react_1.default.createElement(react_3.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null)))))));
};
exports.Category = Category;
var truncateStyle = (0, react_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n"], ["\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n"])));
var templateObject_1;
